// @flow

import ACFPdbGallery from './pdbGallery.acf';

export default ACFPdbGallery;
